<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Category List</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Category Table</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="top-bar">
      <div class="filter-user">
        <button type="button"
                class="el-button el-button--primary"
                @click="goToAddCategory">
          <span>Add new</span>
        </button>
      </div>
      <el-input
          v-model="searchQuery"
          placeholder="Search by name"
          style="margin-bottom: 20px; width: 300px;"
      ></el-input>
    </div>
    <el-table
        ref="indexingTable"
        :data="filteredTags"
        style="width: 100%;"
    >
      <el-table-column label="#" type="index"></el-table-column>

      <el-table-column prop="name" label="Name">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column prop="slug" label="Slug">
        <template slot-scope="scope">
          {{ scope.row.slug }}
        </template>
      </el-table-column>

      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)"
          >Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteCategory(scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderSortTitle from "../../../../components/UsersList/HeaderSortTitle.vue";

export default {
  name: 'IndexingPages',
  components: {HeaderSortTitle},
  data () {
    return {
      searchQuery:''
    }
  },
  computed: {
    ...mapGetters({
      categories: 'category/getCategories',
    }),
    filteredTags() {
      return this.categories.filter(tag =>
          tag.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  created () {
    let params = '';
    if (this.countNets) {
      params = {
        per_page: this.countNets,

      }
    }
    this.$store.dispatch('category/getCategories', params)
  },
  mounted () {
    this.getCategories();
  },
  methods: {
    ...mapActions('category', ['getCategories']),
    deleteCategory(category) {
      this.$store.dispatch('category/deleteCategory', category.id)
    },
    handleEdit(row) {
      this.$router.push({name: 'category-edit', params: {id: row.id}})
    },
    goToAddCategory(){
      this.$router.push({name: 'category-create'})
    }
  }
}
</script>